const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "user_name_contains",
      label: "Exported by",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "name_contains",
      label: "Exported name",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter.vue"),
    props: {
      filterName: "created_at",
      label: "Exported on",
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/admin/logs/export-logs-filters.js